import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { AuthenticationWrapper } from './authentication/AuthenticationWrapper';
import { ToastProvider } from 'src/contexts/ToastContext';
import { CampaignAutomationPage } from './pages/campaignAutomation/CampaignAutomationPage';
import theme from '../theme';

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <ToastProvider>
        <AuthenticationWrapper>
          <CampaignAutomationPage />
        </AuthenticationWrapper>
      </ToastProvider>
    </ThemeProvider>
  );
};

export default App;
